import { render, staticRenderFns } from "./OutboundsNoticeOfLossSelector.vue?vue&type=template&id=b35e4b8a&scoped=true&"
import script from "./OutboundsNoticeOfLossSelector.vue?vue&type=script&lang=ts&"
export * from "./OutboundsNoticeOfLossSelector.vue?vue&type=script&lang=ts&"
import style0 from "./OutboundsNoticeOfLossSelector.vue?vue&type=style&index=0&id=b35e4b8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35e4b8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCardTitle,VCol,VContainer,VDataTable,VRow,VTextField})
